(($) => {

    $.fn.ajaxForm = function () {
        this.on('submit', event => {
            event.preventDefault();
            const form = $(event.target);
            const action = form.attr('action');
            const method = form.attr('method');
            const successModalId = form.data('ajaxSuccessModal');
            const errorModalId = form.data('ajaxErrorModal');
            const data = form.serialize();
            form.addClass('ajax-pending');
            $.ajax({
                type: method,
                url: action,
                data: data,
                success: () => {
                    const containingModal = form.parents('.modal');
                    if (containingModal.length > 0) {
                        containingModal.modal('hide');
                    }
                    if (successModalId) {
                        const successModal = $('#' + successModalId);
                        successModal.modal('show');
                    }
                },
                error: () => {
                    if (errorModalId) {
                        const errorModal = $('#' + errorModalId);
                        errorModal.modal('show');
                    }
                },
                complete: () => {
                    form.removeClass('ajax-pending');
                },
            })
        });
    };

})(jQuery);
